import { tPatientModel } from 'src/app/models/tPatientModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';

import { saveAs } from 'file-saver';
import { tConsultHeadModelWithPatientInfo, tConsultHeadModel } from '../models/tConsultHeadModel';
import { NavigationComponent } from '../pages/navigation/navigation.component';
import { tShoppingCartModelWithItemCateInfo, tShoppingCartModel } from '../models/tShoppingCartModel';


@Injectable({
    providedIn: 'root'
})

export class tShoppingCartService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tShoppingCartModels';


    getShoppingCart(shopID: string, voucherID: string) {
        return this.http.get<tShoppingCartModelWithItemCateInfo[]>(
            this.baseurl + this.pathName + '/GetShoppingCart/' + shopID + '/' + voucherID);
    }

    getPatchShoppingCartPreview(shopID: string, voucherID: string) {
        return this.http.get<tShoppingCartModelWithItemCateInfo[]>(
            this.baseurl + this.pathName + '/GetPatchShoppingCartPreview/' + shopID + '/' + voucherID);
    }




    addData(data: tShoppingCartModel) {
        return this.http.post(this.baseurl + this.pathName + '/PostShoppingCart', data).pipe(shareReplay(1));
    }

    updateData(data: tShoppingCartModel) {
        return this.http.put(this.baseurl + this.pathName + '/UpdateShoppingCart', data);
    }

    deleteData(data: tShoppingCartModel) {
        return this.http.delete(this.baseurl + this.pathName + '/DeleteShoppingCart/' + data.id);
    }

    UpdateShoppingCartPrintName(printNameMode: string, userID: string, data: tShoppingCartModel[]) {
        return this.http.put(this.baseurl + this.pathName + '/UpdateShoppingCartPrintName/' + printNameMode + '/' + userID, data);
    }


    ShoppingCartListToBillPay(data: tConsultHeadModel) {
        // tslint:disable-next-line:max-line-length
        return this.http.post(this.baseurl + this.pathName + '/ShoppingCartListToBillPay/' + data.shopID + '/' + data.clthConsultNumber, null);
    }


    //remark: header is list, because of kelvin using the example is List array, just copy it. 
    // Must one column of header , Just [0], didn't have any header size >1
    saveShoppingCartService(data: any) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted/SaveShoppingCartService'
            , data);
    }
}